module.exports = __webpack_public_path__ + "media/images/b_4-9d6972f79072f120fcf9003b027fb42a.jpeg";